import config from 'src/config';
import trackerService from 'api/tracker';

function Ctrl($scope, $sce, $timeout, loggerService, $q, modalService, alertService) {
  $scope.webUrl = $sce.trustAsResourceUrl(config.WEB_URL);

  $scope.loading = true;

  $q.resolve(trackerService.listByAffiliateId($scope.affiliate.id))
    .then(response => {
      $scope.trackingLinks = response;

      mapTrackingLinks();

      $scope.loading = false;
    })
    .catch(error => {
      $scope.loading = false;

      loggerService.error(error);
    });

  $scope.createTrackerForm = {};

  $scope.isSubmittingCreateTracker = null;
  $scope.createTrackerResult = null;
  $scope.createTrackerBtnOptions = {
    buttonInitialIcon: 'icon-left fa fa-image',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Save',
    buttonSubmittingText: 'Saving...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Saved',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error',
    buttonErrorClass: 'animated-button-error'
  };

  $scope.addTracker = function($event) {
    if ($event) $event.preventDefault();

    modalService.addTracker({
        affiliateId: $scope.affiliate.id
      })
      .then(result => {
        if (result && result.tracker) {
          $scope.trackingLinks.push(result.tracker);

          mapTrackingLinks();

          alertService.success('Your tracker has been saved.');
        }

        result.modalInstance.close();

        return null;
      });
  };

  $scope.showSalesTooltip = function(trackingLink) {
    trackingLink.showSalesTooltip = true;

    $timeout(() => {
      trackingLink.showSalesTooltip = false;
    }, 2000);
  };

  $scope.showMembershipTooltip = function(trackingLink) {
    trackingLink.showMembershipTooltip = true;

    $timeout(() => {
      trackingLink.showMembershipTooltip = false;
    }, 2000);
  };

  function getSalesUrl(trackingLink) {
    return `${$scope.webUrl}?trackingId=${trackingLink.id}`;
  }

  function getMembershipSalesUrl(trackingLink) {
    return `${$scope.webUrl}/membership?trackingId=${trackingLink.id}`;
  }

  function mapTrackingLinks() {
    $scope.trackingLinks = $scope.trackingLinks.map(trackingLink => {
      trackingLink.salesUrl = getSalesUrl(trackingLink);
      trackingLink.membershipSalesUrl = getMembershipSalesUrl(trackingLink);
      trackingLink.showTooltip = false;

      return trackingLink;
    });
  }
}

Ctrl.$inject = [
  '$scope',
  '$sce',
  '$timeout',
  'loggerService',
  '$q',
  'modalService',
  'alertService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/tracking/trackingCtrl.js